/**
 * TutorCloseAccountScreen — « Fermer mon compte » d'un tuteur (route `account-close`) : la page et les
 * gestes de l'élève (`<StudentCloseAccountPage>`, `useStudentCloseAccountState`), avec la branche que
 * `DeleteAccountScreen.js` réserve au tuteur — tant qu'il a des élèves, la phrase remplace le bouton
 * (`tutorCloseAccountViewModel`).
 */
import React from "react"
import { useSelector } from "react-redux"

import { StudentCloseAccountPage } from "../../../../../../design-system/student"
import { tutorCloseAccountViewModel } from "../../../../view-models/tutor/Account/tutorCloseAccountViewModel"
import { useStudentCloseAccountState } from "../../student/Account/useStudentCloseAccountState"

export function TutorCloseAccountScreen() {
    const vm = useSelector(tutorCloseAccountViewModel)
    const state = useStudentCloseAccountState()

    return <StudentCloseAccountPage closeBlockedReason={vm.closeBlockedReason} {...state} />
}
